import { render, staticRenderFns } from "./MetricPopoverContent.vue?vue&type=template&id=6f178cb8&scoped=true&"
import script from "./MetricPopoverContent.vue?vue&type=script&lang=js&"
export * from "./MetricPopoverContent.vue?vue&type=script&lang=js&"
import style0 from "./MetricPopoverContent.vue?vue&type=style&index=0&id=6f178cb8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f178cb8",
  null
  
)

export default component.exports